import { Slider, styled } from '@mui/material';

export const IOSSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.primary.main,
  height: 2,
  padding: '15px 0',
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: theme.shadows[4],
      '@media (hover: none)': {
        boxShadow: theme.shadows[4],
      },
    },
  },
  '& .MuiSlider-valueLabel': {
    fontWeight: 'normal',
    top: -9,
    paddingInline: 16,
    paddingBlock: 8,
    borderRadius: 6,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    border: '1px solid $d8dade',
    boxShadow: theme.shadows[4],
    background: '#fff',
    fontSize: theme.typography.body1.fontSize,
    '&:before': {
      position: 'absolute',
      width: 8,
      height: 8,
      transform: 'translate(-50%, 50%) rotate(45deg)',
      bottom: 0,
      left: '50%',
    },
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#bfbfbf',
    height: 10,
    width: 10,
    borderRadius: '50%',
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: 'currentColor',
    },
  },
  '& .MuiSlider-markLabel': {
    top: 35,
    fontSize: theme.typography.body1.fontSize,
  },
}));
